import { Injectable } from '@angular/core';
import { AuthorizationData } from 'fl-platform-authorizer';
import { DataService } from '../../../data.service';
import { SessionStorageKeys } from '../../SessionStorageKeys';
import { isLoggedIn } from '../../utils/LoginUtils';
import { AuthService } from '../auth/auth.service';
import { ConfigService } from '../config/config.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { RuleService } from '../location/rule.service';
import { PlaybackService } from '../playback/playback.service';
import { AdobeService } from '../adobe/adobe.service';

@Injectable()
export class AppLoadService {
  constructor(
    private configService: ConfigService,
    private dataService: DataService,
    private playbackService: PlaybackService,
    private authService: AuthService,
    private localStorage: LocalStorageService,
    private ruleService: RuleService,
    private adobeService: AdobeService
  ) {
    const splashStart = sessionStorage.getItem(SessionStorageKeys.ELAPSED_SPLASH)
      ? parseInt(sessionStorage.getItem(SessionStorageKeys.ELAPSED_SPLASH), 10)
      : 0;
    sessionStorage.clear();
    sessionStorage.setItem(SessionStorageKeys.ELAPSED_SPLASH, '' + splashStart);
  }

  public async getSettings(): Promise<void> {
    try {
      // Calculate time to download config

      const confStart = new Date().getTime();
      sessionStorage.setItem(SessionStorageKeys.CONF_START, '' + confStart);

      await this.configService.getConfig();
      if (isLoggedIn(this.localStorage)) {
        await this.adobeService.silentLogin().toPromise();
      }
      // Time to appConfig in smart tv include -> App config, xauth, geolocation
      this.dataService.configTime = new Date().getTime() - confStart;

      // Initialise sdk
      this.playbackService.intializeConfigurations(this.configService.applicationConfig);

      const token = await this.getAuthData();
      // Get channels for policy
      await this.ruleService.getHttpGeolocation(this.configService.applicationConfig, token.accessToken);

      return Promise.resolve();
    } catch (e) {
      return Promise.resolve();
    }
  }

  private async getAuthData(): Promise<AuthorizationData> {
    return await this.authService.getAuthData();
  }
}
